<template>
<ul class="text-xl font-bold font-heading">
	<li class="mb-8"><router-link to="/" aria-label="Home">หน้าหลัก</router-link></li>
	<li class="mb-8"><router-link to="/course" aria-label="Course">หลักสูตร ส.อ.ท.</router-link></li>
	<li class="mb-8"><router-link to="/about" aria-label="About Me">เกี่ยวกับเรา</router-link></li>
	<li><router-link to="/contact" aria-label="Contact">ติดต่อเรา</router-link></li>
</ul>
</template>